<template>
	<div class="fatparticles">
		<Loading msg="loading" v-if="!isload" />
		<div class="fatparticles_inner" v-else>
    <!-- 基因有讲究  脂肪粒 -->
 <div class="fat_particles report_box">
        <div class="fat_particles_back finding_page_back" @click="$parent.goBack()"></div>
        <img src="https://static.inertiabiotech.com/uniskin/reportv3/images/fat_particles_head_pic.png" class="fat_particles_title_pic finding_page_title_pic lazy" alt="">
        <div class="fat_particles_body">
            <div class="finding_page_padding_class">
                <h4 class="fat_particles_title finding_page_title">脂肪粒科普</h4>
                <div class="fat_particles_title_tip finding_page_title_tip">眼周的白点到底是什么</div>

                <div class="split_line"></div>
                <p class="fat_particles_sub_text finding_page_sub_text">我们平时提到的脂肪粒，很大程度上是指粟丘疹。
                </p>

                <img src="https://static.inertiabiotech.com/uniskin/reportv3/images/fat_particles_sample_pic.png" class="fat_particles_sample_pic"
                    alt="">
                <p class="fat_particles_sample_tip">(图片来源:来自维基百科网页)</p>
            </div>

            <div class="finding_page_info_box">


                <div class="finding_page_info_item finding_page_padding_class">
                    <div class="finding_page_info_item_title">什么是粟丘疹？</div>
                    <p class="finding_page_info_item_text">粟丘疹（milia）是小小的（一般大小不超过3毫米）、白色的、像珍珠一样硬硬的良性角质囊肿。它是皮肤细胞或者角蛋白堵塞在皮肤表面形成的白色突起。
                        <br>粟丘疹非常普遍，它可以发生在任何年龄，新生儿到老人都可能会长。
                        <br>临床上根据粟丘疹形成的原因，分为先天型和后天形成。
                        <br>
                        <strong>先天型粟丘疹</strong>:研究人员比较了1992-新生儿出生时就有的面部粟丘疹。
                        <br>
                        <strong>后天形成粟丘疹</strong>:一般是疾病相关，或者创伤相关形成的。最常见的是在眼睛周围、脸颊、鼻子和前额，它不疼也不痒，对皮肤并无影响。
                    </p>
                </div>

                <div class="finding_page_info_item">
                    <div class="finding_page_info_item_title">脂肪粒形成原因</div>
                    <p class="finding_page_info_item_text finding_page_padding_class">其实我们所说的脂肪粒，大部分指的是在面部，尤其是眼部形成的。分析它形成的原因，可能
                        <strong>属于后天形成粟丘疹中的创伤相关</strong>。</p>
                    <div class="finding_page_info_item_list_with_bg_title" style="padding:0.76rem 0.6rem 0.4rem;">具体原因可能为：</div>
                    <ul class="finding_page_info_item_list_with_bg_ul">
                        <li class="finding_page_info_item_list_with_bg_li">当
                            <strong>皮肤角质没有正常更新换代</strong>，或死去的细胞没有正常脱落，就会在皮肤表面形成粟丘疹</li>
                        <li class="finding_page_info_item_list_with_bg_li">有些粟丘疹可能是由
                            <strong>皮肤损伤</strong>（如：烧伤或晒伤）、皮疹等引起的 </li>
                    </ul>

                    <p class="finding_page_info_item_text_oth" style="padding:0.34rem 0.6rem 0;">有些人在眼部使用了不适合的眼霜，比如过分油腻，会一下子长出脂肪粒，这个时候可能是因为这些
                        <strong>过分滋润的眼霜</strong>（或者面霜不小心涂抹在眼部位置）
                        <strong>加速了角质细胞在表皮细胞的堆积</strong>而促使脂肪粒形成。</p>


                </div>


                <div class="finding_page_info_item finding_page_padding_class">
                    <div class="finding_page_info_item_title">如何祛除粟丘疹</div>
                    <p class="finding_page_info_item_text">其实大部分粟丘疹是可以
                        <strong>自行消退</strong>的，只是需要较长的时间，几个月甚至是几年；使用一些方法也可以祛除，但是要申明一点，想用眼霜祛除粟丘疹是不太现实的想法。</p>
                    <div class="finding_page_info_item_bordered_title">祛除粟丘疹的方法和注意点：</div>
                    <ul class="finding_page_info_item_bordered_ul">
                        <li class="finding_page_info_item_bordered_li">
                            <span class="finding_page_info_item_bordered_li_title">不要用手挤</span>
                            <p class="finding_page_info_item_bordered_li_text">形成粟丘疹的白色小块非常硬，它的结构与粉刺不同，并不存在于皮肤毛孔中，强行挤压白色小块也无处可去，反而会形成红斑，损伤皮肤。
                            </p>
                            <img src="https://static.inertiabiotech.com/uniskin/reportv3/images/fat_particles_down_pic.png" class="finding_page_info_item_bordered_li_pic"
                                alt="">
                            <p class="finding_page_info_item_bordered_li_pic_tip">粟丘疹的组织学切片
                                <br>(图片来源:来自文献《Milia: A review and classification》) </p>
                        </li>

                        <li class="finding_page_info_item_bordered_li">
                            <span class="finding_page_info_item_bordered_li_title">外用类维生素A</span>
                            <p class="finding_page_info_item_bordered_li_text">如果脂肪粒离眼部较远，并且皮肤屏障状态很好，可以在有脂肪粒的部位局部使用类维生素A，如阿达帕林（建议去正规皮肤科医院询问医生后使用），加速死皮细胞脱落，从而溶解栓塞的角质。
                            </p>

                        </li>
                        <li class="finding_page_info_item_bordered_li">
                            <span class="finding_page_info_item_bordered_li_title">使用消毒手术刀</span>
                            <p class="finding_page_info_item_bordered_li_text">用消毒手术刀的小刀片在粟丘疹表面开个小口，将栓塞物轻轻推出。建议去专门的皮肤科医院或找有资质的美容师操作。
                            </p>

                        </li>

                    </ul>
                </div>

                <div class="finding_page_info_item finding_page_padding_class">
                    <div class="finding_page_info_item_title">如何预防粟丘疹？</div>
                    <ul class="finding_page_info_item_list_box">
                        <li class="finding_page_info_item_list">温柔对待眼部皮肤，避免过度清洁、摩擦眼部等，防止造成肉眼看不见的细小损伤。</li>
                        <li class="finding_page_info_item_list">避免在眼部涂抹厚重的面霜或者眼霜。</li>
                        <li class="finding_page_info_item_list">做好眼部防晒。有分析显示，日晒对皮肤造成的损伤，也有可能使皮肤表皮增厚、角质堆积，从而形成脂肪粒。所以做好眼部防晒非常重要，阳光强烈的时候，一定要佩戴太阳镜。</li>
                    </ul>
                </div>


            </div>
        </div>
    </div>


        </div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";

export default {
  name: "FatParticle",
  data() {
    return {
      isload: true
    };
  },

  created() {
    console.log("fatparticle created", this);
    
  },
  mounted() {
    //判断内容是否少于一屏
    let window_h = window.innerHeight;
    let body_h = document.querySelector("body").offsetHeight;
    if (body_h <= window_h) {
      document.querySelector("body").style.height = window_h + "px";
      document.querySelector("body").style.backgroundColor = "#f9f8f8";
    }
  },
  methods: {
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
body,
html {
  background: #eee;
  height: 100%;
}
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 99999;
  width: 118/50rem;
  height: 54/50rem;
}
.report_page {
  box-sizing: border-box;
  position: relative;
}

/* 基因有讲究 脂肪粒 */

.finding_page_back{
    position:fixed;
    z-index:888;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    background:url("https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png") no-repeat 0 0;
    background-size:100%;
}
.finding_page_title_pic{
    display:block;
    width:100%;
}
.finding_page_title{
    padding:0.82rem 0rem 0.36rem;
    font-size:0.8rem;
    line-height:1em;
    color:#000;
    font-weight:bold;
}
.finding_page_title_tip{
  font-weight:normal;
  padding:0 0rem;
  font-size:0.68rem;
  line-height:1em;
  font-weight:1em;
  color:#666;  
}
.split_line{
    margin:1.9rem 0 0rem;
    height:1px;
    width:2.72rem;
    background:@font-c-detail;
}
.fat_particles_body{
    padding:0 0.6rem;
    background:@bg_c_l;
}

.finding_page_sub_text{
    font-size:0.56rem;
    font-weight:lighter;
    line-height:1.43em;
    color:#000;
    padding:0.88rem 0rem 1.2rem;
}
.finding_page_sub_text strong{
    border-bottom:1px solid @font-c-detail;
}

.finding_page_info_box{
    padding:0.52rem 0 4rem;
}
.finding_page_info_item{
    padding:1.56rem 0 0;
}
.finding_page_info_item_title{
    position:relative;
    padding-left:0.48rem;
    font-size:0.72rem;
    color:@font-c-detail;
    line-height:1em;
}
.finding_page_info_item_title::before{
    content:"";
    display:block;
    position:absolute;
    left:0;
    top:50%;
    transform:translateY(-50%);
    width:0.12rem;
    height:0.44rem;
    background:@font-c-detail;
}
.finding_page_info_item_text{
    padding:0.8rem 0 0;
    font-weight:lighter;
    color:#000;
    font-size:0.56rem;
    line-height:1.43em;
}
.finding_page_info_item_text strong{
    border-bottom:1px solid @font-c-detail;
}

.finding_page_info_item_list_box{
    padding-top:0.8rem;
}
.finding_page_info_item_list{
    position:relative;
    padding:0 0 0.56rem 0.36rem;
    font-size:0.56rem;
    line-height:1.43em;
}
.finding_page_info_item_list::before{
    content:"";
    display:block;
    width:5px;
    height:5px;
    border-radius:50%;
    background:@font-c-detail;
    position:absolute;
    top:0.3rem;
    left:0;
}
.fat_particles_sample_pic {
  width: 100%;
  height: 10.56rem;
}
.fat_particles_sample_tip {
  text-align: center;
  font-size: 0.56rem;
  line-height: 0.8rem;
  padding: 0.24rem 0 0.26rem;
}
.fat_particles .finding_page_info_box {
  padding: 0 0 4rem;
}
.finding_page_info_item_list_with_bg_title {
  padding: 0.76rem 0 0.4rem;
  font-size: 0.56rem;
  line-height: 0.74rem;
  color: rgb(102, 102, 102);
}
.finding_page_info_item_list_with_bg_ul {
  background: rgb(230, 230, 230);
  padding: 0.4rem 0.6rem 0;
}
.finding_page_info_item_list_with_bg_li {
  position: relative;
  padding: 0 0 0.4rem 0.36rem;
  font-size: 0.56rem;
  line-height: 0.8rem;
  letter-spacing: 0;
  color: #000;
}
.finding_page_info_item_list_with_bg_li::before {
  content: "";
  display: block;
  position: absolute;
  top: 0.3rem;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: @font-c-detail;
}
.finding_page_info_item_list_with_bg_li strong,
.finding_page_info_item_text_oth strong {
  border-bottom: 1px solid @font-c-detail;
}
.finding_page_info_item_text_oth {
  font-size: 0.56rem;
  line-height: 0.8rem;
  color: rgb(51, 51, 51);
  padding: 0.34rem 0 0;
}
.finding_page_info_item_bordered_title {
  padding: 0.66rem 0 0.2rem;
  font-size: 0.56rem;
  line-height: 0.84rem;
  color: rgb(102, 102, 102);
}
.finding_page_info_item_bordered_li_title {
  display: inline-block;
  position: relative;
  margin: 0 0 0 0.44rem;
  font-size: 0.56rem;
  line-height: 1.1em;
  border-bottom: 1px solid @font-c-detail;
}
.finding_page_info_item_bordered_li_title::before {
  content: "";
  display: block;
  position: absolute;
  top: 0.25rem;
  left: -0.44rem;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: @font-c-detail;
}
.finding_page_info_item_bordered_li_text {
  padding: 0.1rem 0 0.26rem 0.44rem;
  font-size: 0.56rem;
  line-height: 0.8rem;
}
.finding_page_info_item_bordered_li_pic {
  display: block;
  width: 100%;
  height: 10.56rem;
  margin: 0.5rem 0 0.24rem;
}
.finding_page_info_item_bordered_li_pic_tip {
  font-size: 0.56rem;
  line-height: 0.8rem;
  color: rgb(51, 51, 51);
  text-align: center;
  padding-bottom: 1.36rem;
}
</style>
